import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import { ExcelButton } from "@/controls/buttons/ExcelButton";

interface Props {
	start: Moment;
	end: Moment;
	scrapped: boolean;
	broken: boolean;
	returned: boolean;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	onScrappedChange: (value: boolean) => void;
	onBrokenChange: (value: boolean) => void;
	onReturnedChange: (value: boolean) => void;
	onExportExcel: () => void;
}

export const ReturnedRollsToolbar = ({
	start,
	end,
	scrapped,
	broken,
	returned,
	onStartChange,
	onEndChange,
	onScrappedChange,
	onBrokenChange,
	onReturnedChange,
	onExportExcel,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Start"
					format="MM/DD/YYYY"
					value={start}
					maxDate={end}
					onChange={onStartChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Close"
					format="MM/DD/YYYY"
					value={end}
					minDate={start}
					onChange={onEndChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>

			<FormControlLabel
				control={
					<Checkbox
						size="small"
						checked={returned}
						onChange={(e) => onReturnedChange(e.target.checked)}
					/>
				}
				label="Returned"
			/>
			<FormControlLabel
				control={
					<Checkbox
						size="small"
						checked={scrapped}
						onChange={(e) => onScrappedChange(e.target.checked)}
					/>
				}
				label="Scrapped"
			/>
			<FormControlLabel
				control={
					<Checkbox
						size="small"
						checked={broken}
						onChange={(e) => onBrokenChange(e.target.checked)}
					/>
				}
				label="Broken"
			/>

			<Box sx={{ flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ width: 200 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
			</Box>
		</Box>
	);
};
